import loadable from '@loadable/component';
import productComparePageQuery from './query.graphql';

const ProductComparePage = loadable(() =>
  import(/* webpackChunkName: "product-compare" */ './product-compare')
);

ProductComparePage.MAX_PRODUCTS = 40;

ProductComparePage.graphQL = productComparePageQuery;

ProductComparePage.variables = ({ categoryId, productIds }) => ({
  categoryId: categoryId || 0,
  fetchCategory: !!categoryId,
  productIds:
    typeof productIds !== 'string'
      ? []
      : productIds
          .split(',')
          .map(item => parseInt(item, 10))
          .filter((id, index, arr) => !isNaN(id) && arr.indexOf(id) === index) // only keep unique, valid integers
          .slice(0, ProductComparePage.MAX_PRODUCTS),
});

export default ProductComparePage;
